export default __webpack_public_path__ + "static/Entenda0150-6c0212d457ab6560c877a7203426c11a.jpg";